import { combineReducers } from 'redux';
import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory'

import actionTypes from './actionTypes';
/* State shape
 {
     loadingState: {
         isLoading: bool,
         success: bool,
         error: Object
     },
     teamsState: {
        availableTeams: Object
     }
 }
 */

export const ACTIVE_SEASON_IDENTIFIER = 'active';

const teamsLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_TEAMS)(actionTypes.TEAMS_RESPONSE);
const teamGameLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_GAMES_FOR_TEAM)(actionTypes.GAMES_FOR_TEAM_RESPONSE);
const teamSocialAccountsLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_TEAM_SOCIAL_ACCOUNTS)(actionTypes.TEAM_SOCIAL_ACCOUNTS_RESPONSE);
const gameNotesLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_GAME_NOTES)(actionTypes.GAME_NOTES_RESPONSE);

const availableTeamsReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.TEAMS_RESPONSE:
            return Object.assign({}, {[action.payload.season]: action.payload.teams}, state);
        default: return state;
    }
};

const gamesForTeamReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.GAMES_FOR_TEAM_RESPONSE:
            return action.payload.team;
        default: return state;
    }
};

const teamLogosReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.LOGO_ASSETS_RESPONSE:
            return action.payload.logos;
        default: return state;
    }
};

const teamSocialAccountsReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.TEAM_SOCIAL_ACCOUNTS_RESPONSE:
            return action.payload.accounts;
        default: return state;
    }
};

const gameNotesReducer = (state = {}, action) => {
    if (action.type === actionTypes.GAME_NOTES_RESPONSE) {
        return Object.assign({}, state, {[action.payload.teamId]: action.payload.gameNotes});
    }

    return state;
};

const loadingStateReducer = combineReducers({
    teamsLoadingState: teamsLoadingStateReducer,
    teamGameLoadingState: teamGameLoadingStateReducer,
    teamSocialAccountsLoadingState: teamSocialAccountsLoadingStateReducer,
    gameNotesLoadingState: gameNotesLoadingStateReducer
});

const teamsStateReducer = combineReducers({
    availableTeams: availableTeamsReducer,
    gamesForTeam: gamesForTeamReducer,
    teamLogos: teamLogosReducer,
    teamSocialAccounts: teamSocialAccountsReducer,
    gameNotes: gameNotesReducer,
});

const reducer =  combineReducers({
    loadingState: loadingStateReducer,
    teamsState: teamsStateReducer
});

export default reducer;
